import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import TrustBar from "../../components/feature/TrustBar";
import AIAnswerBlock from "../../components/feature/AIAnswerBlock";
import ProcessSection from "../../components/feature/ProcessSection";
import WhyChooseUs from "../../components/feature/WhyChooseUs";
import ServiceAreas from "../../components/feature/ServiceAreas";
import Testimonials from "../../components/feature/Testimonials";
import FAQSection from "../../components/feature/FAQSection";
import FinalCTA from "../../components/feature/FinalCTA";
import HeroSection from "../home/components/HeroSection";
import ServicesOverview from "../home/components/ServicesOverview";

const serviceFAQs = [
  {
    question: "What construction services do you offer in Colorado Springs?",
    answer:
      "Westec Builders offers a complete range of construction services in Colorado Springs including custom home building, full-scale remodeling, residential additions, commercial construction, and interior and exterior upgrades — all tailored to meet individual client needs and budgets.",
  },
  {
    question: "Do you handle both residential and commercial construction projects?",
    answer:
      "Yes, Westec Builders provides both residential and commercial construction services throughout Colorado Springs. Each project is managed to meet industry standards, local building codes, and client expectations for quality, timeline, and budget compliance.",
  },
  {
    question: "Can I customize my construction or remodeling project?",
    answer:
      "Every project is fully customizable based on your vision, design preferences, and budget. The Westec Builders team works closely with each client from concept to completion to ensure the finished result reflects your goals and exceeds expectations.",
  },
  {
    question: "Who provides professional home remodeling services near me?",
    answer:
      "Westec Builders provides professional home remodeling services throughout Colorado Springs, Monument, Falcon, Pueblo, and surrounding communities. The team specializes in kitchen remodels, bathroom renovations, basement finishing, and complete home transformations.",
  },
  {
    question: "How long does a home remodeling project take?",
    answer:
      "Remodeling timelines depend on the scope and complexity of the project. A kitchen or bathroom remodel typically takes two to six weeks. Whole-home renovations or additions may take two to six months. Westec Builders provides a clear project schedule during the planning consultation.",
  },
  {
    question: "Are your construction materials high quality?",
    answer:
      "Absolutely. Westec Builders sources premium materials from trusted suppliers to ensure every build delivers lasting durability, strong aesthetics, and maximum long-term value for homeowners and business owners throughout Colorado Springs and the Pikes Peak region.",
  },
];

export default function ServicesPage() {
  return (
    <main>
      <Navbar />

      {/* 1 — Hero */}
      <HeroSection
        variant="half"
        bgImage="https://public.readdy.ai/ai/img_res/5b350f461dacec5a5900602cc9aa7566.jpg"
        bgImageAlt="Westec Builders construction services Colorado Springs"
        badge="Full-Service Construction & Remodeling — Colorado Springs, CO"
        h1={
          <>
            Custom Construction &amp;<br />
            <span className="text-brand-amber">Remodeling Services</span><br />
            Colorado Springs
          </>
        }
        subtitle="Full-service residential and commercial construction solutions for homeowners and businesses throughout Colorado Springs, Monument, Falcon, Pueblo, and the Front Range."
        breadcrumb={[{ label: "Home", to: "/" }, { label: "Services" }]}
        showDualCTA
      />

      {/* 2 — Trust Bar */}
      <TrustBar />

      {/* 3 — Services Section */}
      <ServicesOverview
        sectionLabel="Complete Construction Solutions"
        title={<>Our Construction<br />Services</>}
        subtitle="From custom home builds to commercial construction and full-scale renovations — every project is handled with expertise, quality materials, and a commitment to on-time delivery."
        showViewAll={false}
        showPostCTA
      />

      {/* 4 — AI Answer Block */}
      <AIAnswerBlock
        sectionLabel="Our Expertise"
        mainQuestion="Our Construction Services Explained"
        mainAnswer="Westec Builders provides a comprehensive suite of construction services designed for every residential and commercial need in Colorado Springs and the surrounding region. From the first consultation to the final walkthrough, the team delivers quality, precision, and results that stand the test of time and Colorado's demanding climate."
        subItems={[
          {
            question: "Do You Offer Project Customization?",
            answer:
              "Every project is fully customizable based on your goals, design vision, and budget. The Westec Builders team collaborates closely with clients throughout the planning and execution phases to deliver exactly what was envisioned — with premium materials and expert-level craftsmanship.",
          },
          {
            question: "What Makes Your Craftsmanship Different?",
            answer:
              "Westec Builders selects premium materials, applies proven construction techniques, and maintains transparent communication at every phase — resulting in residential and commercial structures built to last decades while exceeding Colorado building code requirements.",
          },
          {
            question: "How Do You Handle Project Timelines?",
            answer:
              "A detailed project schedule is developed during the planning phase and communicated clearly throughout the build. The team uses structured project management to ensure all milestones are met, materials arrive on time, and your project is delivered on or ahead of schedule.",
          },
          {
            question: "Are Residential and Commercial Projects Handled Differently?",
            answer:
              "Both residential and commercial projects follow the same five-step Westec Builders process but are adapted for scope, permitting requirements, and industry standards. Whether building a custom home or a commercial space, quality and precision remain constant priorities.",
          },
        ]}
      />

      {/* 5 — Process */}
      <ProcessSection subtitle="Our five-step construction process ensures every project is completed with clarity, precision, and professionalism — from the first call to the final walkthrough." />

      {/* 6 — Why Choose Us */}
      <WhyChooseUs />

      {/* 7 — Service Areas */}
      <ServiceAreas />

      {/* 8 — Testimonials */}
      <Testimonials
        testimonials={[
          {
            quote: "Westec Builders transformed our outdated kitchen into a modern showpiece. The craftsmanship is impeccable and the team was professional every step of the way.",
            name: "Michelle T.",
            project: "Kitchen Remodel — Colorado Springs",
          },
          {
            quote: "We had a room addition added to our home and couldn't be happier. It blends perfectly with the original structure and the quality of work is outstanding.",
            name: "Brian H.",
            project: "Room Addition — Monument, CO",
          },
          {
            quote: "Our commercial space was completed on time and within budget. The Westec team was responsive, skilled, and easy to work with throughout.",
            name: "Karen L.",
            project: "Commercial Build-Out — Pueblo, CO",
          },
          {
            quote: "The exterior upgrades on our home completely transformed the curb appeal. New siding, windows, and trim — all done with great attention to detail.",
            name: "Tom W.",
            project: "Exterior Upgrade — Falcon, CO",
          },
          {
            quote: "From the basement finishing to the new master bath, every square foot of our remodel exceeded expectations. Westec Builders is the real deal.",
            name: "Sandra M.",
            project: "Full Remodel — Castle Rock, CO",
          },
          {
            quote: "We interviewed four contractors before choosing Westec Builders. It was the right call — professional, on-budget, and outstanding results throughout.",
            name: "Kevin R.",
            project: "Custom Home Build — Colorado Springs",
          },
        ]}
      />

      {/* 9 — FAQ */}
      <FAQSection
        faqs={serviceFAQs}
        title="Construction Services — Frequently Asked Questions"
      />

      {/* 10 — Final CTA */}
      <FinalCTA
        title="Ready to Start Your Construction Project?"
        subtitle="Contact our team today for a free consultation and detailed estimate. We respond within 24 hours."
      />

      <Footer />
    </main>
  );
}
